import React from 'react';
import I18n from 'i18n-js';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import { getNotebookPath } from '@/components/shared/LessonOverview/Cards/NotebookCards';
import LessonSubheader from '../LessonSubheader';
import AssessmentsCard from '../Cards/AssessmentsCard';
import LessonGameCard from '../Cards/LessonGameCard';
import NotebookCard from '../Cards/NotebookCard';
import Grid from '../Cards/Grid';

interface AssessWithProps {
  subheaderNumber?: number;
}

const AssessWith = ({ subheaderNumber }: AssessWithProps) => {
  const lesson = useLessonOverviewContext(state => state.lesson);
  const sections = useLessonOverviewContext(state => state.sections);
  const program = useLessonOverviewContext(state => state.program);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);
  const hasAssessments = useLessonOverviewContext(state => state.hasAssessments);
  const assessWithColor = '#2A8806';

  return (
    <LessonSubheader
      subheaderNumber={subheaderNumber}
      title={I18n.t('assess')}
    >
      <Grid>
        {sections.map(
          section => section.notebooks.map(notebook => (
            <NotebookCard
              key={notebook.id}
              fastTrack={notebook.fastTrack}
              iconColor={assessWithColor}
              notebookName={notebook.title}
              notebookPath={getNotebookPath(section, notebook, lesson, program)}
              section={section}
              type="notebook"
            />
          )),
        )}

        {lesson.lessonGameAssignables.length > 0 && (
          <LessonGameCard iconColor={assessWithColor} type="lesson-game" />
        )}

        {(hasAssessments || isStaffer) && (
          <AssessmentsCard iconColor={assessWithColor} type="assessments" />
        )}
      </Grid>
    </LessonSubheader>
  );
};

export default AssessWith;
